import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class EnumInputPresentation extends BaseOption {
  static userInterfaceComponent = {
    label: "Presentation",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      displayCaretIcon: true,
      options: [
        { id: "dropdown", name: "Dropdown" },
        { id: "radio", name: "Radio list" },
        { id: "segmented", name: "Segmented bar" },
        { id: "chips", name: "Chips" },
      ],
    },
  };

  static defaultValue = "dropdown";
}
